export enum TenantsEnum {
  seha = 'seha',
  ccad = 'ccad',
  glucare = 'glucare',
  uhg = 'uhg'
}
